import { useState, useEffect } from 'react';
import { queryProcessingNotesForDoctor, getDoctorSignupAndFirstNote } from '../../../utils/functions';

export default function ProcessingNotes({ doctor_id }) {
  const [processingNotes, setProcessingNotes] = useState(null);

  useEffect(() => {
    (async () => {
      setProcessingNotes(await getDoctorSignupAndFirstNote(doctor_id));
    })()
  }, [])

  return (
    <>
      {processingNotes !== null ? (
        <>
          <p>{processingNotes.signup} | {processingNotes.firstNote}</p>
        </>
      ) : (
        <span className="w-6 h-6 border-2 border-dashed rounded-full animate-spin border-ktx-purple mx-auto"></span>
      )
      }
    </>
  )
}